import { render, staticRenderFns } from "./ResultsSection.vue?vue&type=template&id=0b7dd288&scoped=true"
import script from "./ResultsSection.vue?vue&type=script&lang=ts"
export * from "./ResultsSection.vue?vue&type=script&lang=ts"
import style0 from "./ResultsSection.vue?vue&type=style&index=0&id=0b7dd288&prod&scoped=true&lang=css"
import style1 from "./ResultsSection.vue?vue&type=style&index=1&id=0b7dd288&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7dd288",
  null
  
)

export default component.exports